import $api from 'http/index';
import { getKioskOptions } from 'helpers/getOptions';


export const apiCalls = {
  clockIn: async (body) => {
    const response = await $api.post(
      `${process.env.REACT_APP_BASE_URL}/kiosk/clock-in`,
      body,
      getKioskOptions()
    );

    return response;
  },
  clockOut: async (body) => {
    await $api.post(
      `${process.env.REACT_APP_BASE_URL}/kiosk/clock-out`,
      body,
      getKioskOptions()
    );
  },
  injuryReport: async (body) => {
    await $api.post(
      `${process.env.REACT_APP_BASE_URL}/kiosk/injury-report`,
      body,
      getKioskOptions()
    )
  },
  injuryReportConfirmation: async () => {
    await $api.post(
      `${process.env.REACT_APP_BASE_URL}/kiosk/injury-report/confirmation`,
      {},
      getKioskOptions()
    )
  },
};
